// extracted by mini-css-extract-plugin
export default {"main":"PetGroomer_main__tFPoe","formDiv":"PetGroomer_formDiv__BTPi4","form":"PetGroomer_form__5gDmm","input":"PetGroomer_input__+oHfa","select":"PetGroomer_select__IRNZg"};